import Vue from 'vue'
import VueRouter from 'vue-router'
import lanhu_wode from '../views/lanhu_wode/index.vue'
import lanhu_jifenchongzhi from '../views/lanhu_jifenchongzhi/index.vue'
import lanhu_shouye from '../views/lanhu_shouye/index.vue'
import www_gxy_home from '../views/www_gxy_home/index.vue'
import lanhu_yonghudenglu from '../views/lanhu_yonghudenglu/index.vue'
import lanhu_yonghuzhuce from '../views/lanhu_yonghuzhuce/index.vue'
import lanhu_zhanghaoguanli from '../views/lanhu_zhanghaoguanli/index.vue'
import lanhu_tianjiazhanghao from '../views/lanhu_tianjiazhanghao/index.vue'
import lanhu_lunwenshengcheng from '../views/lanhu_lunwenshengcheng/index.vue'
import lanhu_chongzhijilu from '../views/lanhu_chongzhijilu/index.vue'
import system_management from '../views/system_management/index.vue'
import share_sign from '../views/share_sign/index.vue'

Vue.use(VueRouter)

const isWwwGxySite = typeof window !== 'undefined' &&
  window.location.hostname.toLowerCase() === 'www.dxssxdk.com'
const homeComponent = isWwwGxySite ? www_gxy_home : lanhu_shouye

const routes = [
    {
    path: '/',
    redirect: "/lanhu_yonghudenglu"
  },
  {
    path: '/lanhu_wode',
    name: 'lanhu_wode',
    component: lanhu_wode
  },
  {
    path: '/lanhu_jifenchongzhi',
    name: 'lanhu_jifenchongzhi',
    component: lanhu_jifenchongzhi
  },
  {
    path: '/lanhu_shouye',
    name: 'lanhu_shouye',
    component: homeComponent
  },
  {
    path: '/shouye',
    name: 'shouye',
    component: homeComponent
  },
  {
    path: '/lanhu_yonghudenglu',
    name: 'lanhu_yonghudenglu',
    component: lanhu_yonghudenglu
  },
  {
    path: '/login',
    name: 'login',
    component: lanhu_yonghudenglu
  },
  {
    path: '/lanhu_yonghuzhuce',
    name: 'lanhu_yonghuzhuce',
    component: lanhu_yonghuzhuce
  },
  {
    path: '/register',
    name: 'register',
    component: lanhu_yonghuzhuce
  },
  {
    path: '/lanhu_zhanghaoguanli',
    name: 'lanhu_zhanghaoguanli',
    component: lanhu_zhanghaoguanli
  },
  {
    path: '/lanhu_tianjiazhanghao',
    name: 'lanhu_tianjiazhanghao',
    component: lanhu_tianjiazhanghao
  },
  {
    path: '/lanhu_lunwenshengcheng',
    name: 'lanhu_lunwenshengcheng',
    component: lanhu_lunwenshengcheng
  },
  {
    path: '/lanhu_chongzhijilu',
    name: 'lanhu_chongzhijilu',
    component: lanhu_chongzhijilu
  },
  {
    path: '/system_management',
    name: 'system_management',
    component: system_management
  },
  {
    path: '/s/:token',
    name: 'share_sign',
    component: share_sign
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
